module.exports = __webpack_public_path__ + "static/media/blom-pysanky-sm-118.fbb37e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-sm-118.jpg
// module id = 3815
// module chunks = 14